<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="d-flex justify-center align-center" style="min-height:70vh; position:relative;">
                <qrcode-vue
                    :value="`${$route.params.type === 'user' ? 'userId=' + $route.params.id : 'coachId=' + $route.params.id}`"
                    class="mb-5"
                    :size="200"
                    level="H"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import QrcodeVue from 'qrcode.vue'

    export default {
        name: 'UserCoachQrCode',
        components: { QrcodeVue },
        data: () => {
            return {}
        },
        created() {
        },
        methods: {
        }
    }
</script>
